/**
 * Copyright © RINIS 2026
 * Licensed under the EUPL
 */

enablePropertiesTemplates()

document.body.addEventListener('htmx:afterSettle', function () {
  enablePropertiesTemplates()
});

function enablePropertiesTemplates() {
  document
    .querySelectorAll('[data-properties-template-name]')
    .forEach((el) => {
      // first remove the listener in case it was added in a previous HTML request
      el.removeEventListener('click', onClickHandler)
      el.addEventListener('click', onClickHandler)
    })
}

function onClickHandler(event) {
  event.preventDefault()

  const templateName = event.target.dataset.propertiesTemplateName

  let template = ""

  switch (templateName) {
    case "delegation-connection-external-contract":
      template = templateDelegationConnection
      break

    case "delegation-publication-external-contract":
      template = templateDelegationPublication
      break

    case "verantwoording":
      template = templateVerantwoording
      break

    default:
      console.log(`unknown template name '${templateName}'`)
  }

  const targetID = event.target.dataset.propertiesTemplateTargetId
  document.getElementById(targetID).value = template
}

const templateDelegationConnection = `{
  "delegation.connection.external_contract_reference": {
    "delegator_id": "",
    "delegator_name": "",
    "reference": ""
  }
}`

const templateDelegationPublication = `{
  "delegation.publication.external_contract_reference": {
    "delegator_id": "",
    "delegator_name": "",
    "reference": ""
  }
}`

const templateVerantwoording = `{
  "verantwoording": {
    "wettelijke_grondslag": "",
    "verwerkingsrelatie": "",
    "kanaal": ""
  }
}`
